import sha256 from "crypto-js/sha256";
import { v4 as uuidv4 } from "uuid";

/**
 * Generates a unique identifier string with a specified prefix.
 *
 * The function constructs the UID by combining a prefix, the current epoch time's last 8 digits,
 * and the first 8 non-hyphen characters of a UUID v4. The prefix must not exceed 3 characters in length,
 * otherwise, an error is thrown.
 *
 * @param {string} prefix - A string prefix for the UID, must be 3 characters or fewer.
 * @returns {string} The generated unique identifier.
 * @throws {Error} If the prefix exceeds 3 characters in length.
 */

export default function createId(
  prefix: string,
  timeLength: number = 8,
  uuidLength: number = 8,
): string {
  if (prefix.length > 3) {
    throw new Error("Prefix must be a maximum of 3 characters long.");
  }

  // Get the last `timeLength` digits of the current epoch time
  const epochTime = Date.now().toString().slice(-timeLength);

  // Hash the epoch time using SHA-256
  const hashedTime = sha256(epochTime).toString().substring(0, timeLength);

  // Generate a UUID and use the first `uuidLength` characters
  const uuidStr = uuidv4().replace(/-/g, "").substring(0, uuidLength);

  return `${prefix}_${hashedTime}${uuidStr}`;
}
